export const categoryKeys = {
    all: ['categories'],
    list: (params) => ['categories', 'list', params],
};
